import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["bold", "className", "disabled", "element", "inverse", "readOnly", "size", "textAlignRight", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cx from 'classnames';
import React, { forwardRef } from 'react';
import { omitBoxProps } from '../box';
import theme from './theme.css';
var InputBase = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var bold = _ref.bold,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? 'input' : _ref$element,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    textAlignRight = _ref.textAlignRight,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    others = _objectWithoutProperties(_ref, _excluded);
  var classNames = cx(theme['input'], theme["is-".concat(size)], _defineProperty(_defineProperty(_defineProperty({}, theme['is-inverse'], inverse), theme['is-bold'], bold), theme['has-text-align-right'], textAlignRight), className);
  return /*#__PURE__*/React.createElement(element, _objectSpread({
    className: classNames,
    ref: forwardedRef,
    disabled: disabled,
    readOnly: readOnly,
    type: type
  }, omitBoxProps(others)));
});
InputBase.displayName = 'InputBase';
export default InputBase;